import widgetTransformer from '@nykaa/nes-deals-transformer';
import logErrors from '@nykaa/nes-logger/logErrors';

import { ApiHelper } from 'shared/api';
import { getAdPlatformApi } from './helper';
import { queryStringFromParams } from 'shared/helpers/utils/url';

const ERROR_FETCHING_WIDGET = 'Error fetching widgets';
export const getWidgets = async (
  queryParams: any,
  pagePrefix?: string,
  isPaginationEnabled?: boolean
) => {
  const url = getAdPlatformApi();
  const queryString = queryStringFromParams({ ...queryParams });

  try {
    const {
      data: { result },
    } = await ApiHelper(`${url}${queryString}`, 'get');

    const inventoryResult = isPaginationEnabled
      ? result.inventory_data
      : result;

    if (!inventoryResult) {
      throw new Error('"result" not found in widgets api -> data');
    }

    let modifiedResult = inventoryResult;

    if (queryParams.page_data && Array.isArray(inventoryResult)) {
      modifiedResult = inventoryResult.map((inventory: {}) => ({
        ...inventory,
        api_page_data: queryParams.page_data,
      }));
    }

    return {
      widgets: widgetTransformer(
        modifiedResult,
        false,
        __PLATFORM__,
        pagePrefix
      ).widgets,
      remaining_inventories_ids: result.remaining_inventories_ids || [], // For pagination API V2 call
    };
  } catch (e) {
    logErrors(e, `${ERROR_FETCHING_WIDGET} :url=${url}`);
    throw e;
  }
};
